/**
 * Verbose tracing for remote → MQTT → deck TTS codewords.
 * Set `window.__LECTURA_DEBUG_REMOTE_TTS__ = true` then enable Verbose in DevTools to see `console.debug`.
 * Warnings (dropped commands, parse failures) always use `console.warn`.
 */

export const REMOTE_TTS_DEBUG_FLAG = '__LECTURA_DEBUG_REMOTE_TTS__' as const;

export function isRemoteTtsDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return !!(window as unknown as Record<string, unknown>)[REMOTE_TTS_DEBUG_FLAG];
  } catch {
    return false;
  }
}

export function remoteTtsVerbose(message: string, data?: Record<string, unknown>): void {
  if (!isRemoteTtsDebugEnabled()) return;
  if (typeof console !== 'undefined' && console.debug) {
    console.debug(`[lectura][remote-tts] ${message}`, data ?? '');
  }
}

export function remoteTtsWarn(message: string, data?: Record<string, unknown>): void {
  if (typeof console !== 'undefined' && console.warn) {
    console.warn(`[lectura][remote-tts] ${message}`, data ?? '');
  }
}
